import * as React from 'react';
import Divider from 'components/Divider';
// @ts-ignore
import IncludeInOwnBroadcastsPreference from './IncludeInOwnBroadcastsPreference';
// @ts-ignore
import TwoWayChatPreference from './TwoWayChatPreference';
// @ts-ignore
import PhoneCallPreferenceSectionContainer from 'settings/components/PhoneCallPreferenceSectionContainer';
import DeviceSettings from 'settings/components/DeviceSettings';
// @ts-ignore
import OfficeHoursPicker from 'settings/components/OfficeHoursPicker';

type Props = {
  showSmsDevices: boolean;
  isTeacher: boolean;
  twoWayMessagingEnabled: boolean;
};

class CommunicationSettingsView extends React.Component<Props> {
  render() {
    const { showSmsDevices, twoWayMessagingEnabled, isTeacher } = this.props;

    return (
      <div className="CommunicationSettingsView">
        <DeviceSettings showSmsDevices={showSmsDevices} />
        <PhoneCallPreferenceSectionContainer isTeacher={isTeacher} />
        {isTeacher && (
          <div>
            <Divider />
            <TwoWayChatPreference />
            <IncludeInOwnBroadcastsPreference />
            <Divider />
            <OfficeHoursPicker
              twoWayMessagingEnabled={twoWayMessagingEnabled}
              compact
              showToggleButton
              showToastMessages
              showIntroText
            />
          </div>
        )}
      </div>
    );
  }
}

export default CommunicationSettingsView;
